module.exports = __webpack_public_path__ + "static/team-6-c4b08b182c06ca496865afad097d2b62.jpg";